import { styled } from '@mui/material';

export const Root = styled('div')({
  border: '1px solid black',
  position: 'relative',
  overflow: 'hidden',
  width: '80%',
  height: 20,
  borderRadius: 7,
  backgroundColor: '#F0F0F7',
  margin: 'auto',
});

export const Value = styled('div')({
  position: 'absolute',
  lineHeight: '20px',
  fontWeight: 500,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  zIndex: 100,
});

export const Bar = styled('div')({
  opacity: 0.8,
  height: '100%',
  '&.normal': {
    backgroundColor: '#418101',
  },
  '&.alert': {
    backgroundColor: '#ffc107',
  },
  '&.late': {
    backgroundColor: '#D50022',
  },
});
